import { render, staticRenderFns } from "./ShopConsultationTable.vue?vue&type=template&id=7c20af02&scoped=true&"
import script from "./ShopConsultationTable.vue?vue&type=script&lang=js&"
export * from "./ShopConsultationTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopConsultationTable.vue?vue&type=style&index=0&id=7c20af02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c20af02",
  null
  
)

export default component.exports